const Foot_questions = [
   {
      "question":"How is ##name## being evaluated today?",
      "sub":"",
      "type":"radio",
      "telehealth":"form1[0].#subform[0].HowExamCOnducted[0]",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "questions":[
         {
            "label":"How was the examination conducted?",
            "title":"",
            "subMain":"",
            "sub":"",
            "radioGroup":"form1[0].#subform[0].RadioButtonList[3]",
            "options":[
               {
                  "main":"In-Person Exam",
                  "dbqName":"1",
                  "sub":""
               },
               {
                  "main":"Video Telehealth",
                  "dbqName":"2",
                  "sub":""
               }
            ],
            "answer":"In-Person Exam"
         }
      ]
   },
   {
      "question":"Is ##name## regularly seen as a patient in your clinic?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "presidence":"Yes",
      "radioGroup":"form1[0].#subform[0].RadioButtonList[2]",
      "ref":0,
      "dbqName_yes":"1",
      "dbqName_no":"2",
      "answer":"",
   },
   {
      "question":"Did you review any of the patients records for this condition?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "EVIDENCE REVIEW",
         number: "0"
      },
      "presidence":"Yes",
      "maxLength":360,
      "radioGroup":"form1[0].#subform[0].RadioButtonList[0]",
      "ref":0,
      "dbqName_yes":"2",
      "dbqName_no":"1",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please identify the evidence reviewed and the date range",
      "textdbqName":"form1[0].#subform[0].IdentifyEvidence[0]",
      "textanswer":""
   },
   {
      "question":"Perform active range of motion and provide the ROM values for ##redHeading##",
      "redHeading":"Index Finger",
      "sub":"",
      "type":"text",
      "show": true,
      "section": {
         page: "4",
         title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION",
         number: "3"
      },
      "questions":[
         {
            "main":"Right Flexion MCP",
            "subMain":"Normal Endpoint is 90 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].TextField6[121]",
            "defaultVal":"90",
            "values":[
               "90",
               "85",
               "80",
               "75",
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
            ],
            "answer":"90"
         },
         {
            "main":"Right Flexion PIP",
            "subMain":"Normal Endpoint is 100 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].TextField6[146]",
            "defaultVal":"100",
            "values":[
               "100",
               "95",
               "90",
               "85",
               "80",
               "75",
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
            ],
            "answer":"100"
         },
         {
            "main":"Right Flexion DIP",
            "subMain":"Normal Endpoint is 70 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].TextField6[122]",
            "defaultVal":"70",
            "values":[
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
            ],
            "answer":"70"
         },
         {
            "main":"Right Extension MCP",
            "subMain":"Normal Endpoint is 0 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].TextField6[127]",
            "defaultVal":"0",
            "values":[
               "90",
               "85",
               "80",
               "75",
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
               "0",
            ],
            "answer":"0"
         },
         {
            "main":"Right Extension PIP",
            "subMain":"Normal Endpoint is 0 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].TextField6[128]",
            "defaultVal":"0",
            "values":[
               "100",
               "95",
               "90",
               "85",
               "80",
               "75",
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
               "0",
            ],
            "answer":"0"
         },
         {
            "main":"Right Extension DIP",
            "subMain":"Normal Endpoint is 0 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].TextField6[129]",
            "defaultVal":"0",
            "values":[
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
               "0",
            ],
            "answer":"0"
         },
         {
            "main":"Left Flexion MCP",
            "subMain":"Normal Endpoint is 90 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].TextField6[149]",
            "defaultVal":"90",
            "values":[
               "90",
               "85",
               "80",
               "75",
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
            ],
            "answer":"90"
         },
         {
            "main":"Left Flexion PIP",
            "subMain":"Normal Endpoint is 100 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].TextField6[174]",
            "defaultVal":"100",
            "values":[
               "100",
               "95",
               "90",
               "85",
               "80",
               "75",
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
            ],
            "answer":"100"
         },
         {
            "main":"Left Flexion DIP",
            "subMain":"Normal Endpoint is 70 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].TextField6[150]",
            "defaultVal":"70",
            "values":[
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
            ],
            "answer":"70"
         },
         {
            "main":"Left Extension MCP",
            "subMain":"Normal Endpoint is 0 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].TextField6[155]",
            "defaultVal":"0",
            "values":[
               "90",
               "85",
               "80",
               "75",
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
               "0",
            ],
            "answer":"0"
         },
         {
            "main":"Left Flexion PIP",
            "subMain":"Normal Endpoint is 0 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].TextField6[156]",
            "defaultVal":"0",
            "values":[
               "100",
               "95",
               "90",
               "85",
               "80",
               "75",
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
               "0",
            ],
            "answer":"0"
         },
         {
            "main":"Left Flexion DIP",
            "subMain":"Normal Endpoint is 0 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].TextField6[157]",
            "defaultVal":"0",
            "values":[
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
               "0",
            ],
            "answer":"0"
         },
      ]
   },
   {
      "question":"Perform active range of motion and provide the ROM values for ##redHeading##",
      "redHeading":"Long Finger",
      "sub":"",
      "type":"text",
      "show": true,
      "section": {
         page: "4",
         title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION",
         number: "3"
      },
      "questions":[
         {
            "main":"Right Flexion MCP",
            "subMain":"Normal Endpoint is 90 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].TextField6[130]",
            "defaultVal":"90",
            "values":[
               "90",
               "85",
               "80",
               "75",
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
            ],
            "answer":"90"
         },
         {
            "main":"Right Flexion PIP",
            "subMain":"Normal Endpoint is 100 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].TextField6[147]",
            "defaultVal":"100",
            "values":[
               "100",
               "95",
               "90",
               "85",
               "80",
               "75",
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
            ],
            "answer":"100"
         },
         {
            "main":"Right Flexion DIP",
            "subMain":"Normal Endpoint is 70 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].TextField6[131]",
            "defaultVal":"70",
            "values":[
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
            ],
            "answer":"70"
         },
         {
            "main":"Right Extension MCP",
            "subMain":"Normal Endpoint is 0 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].TextField6[132]",
            "defaultVal":"0",
            "values":[
               "90",
               "85",
               "80",
               "75",
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
               "0",
            ],
            "answer":"0"
         },
         {
            "main":"Right Extension PIP",
            "subMain":"Normal Endpoint is 0 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].TextField6[133]",
            "defaultVal":"0",
            "values":[
               "100",
               "95",
               "90",
               "85",
               "80",
               "75",
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
               "0",
            ],
            "answer":"0"
         },
         {
            "main":"Right Extension DIP",
            "subMain":"Normal Endpoint is 0 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].TextField6[134]",
            "defaultVal":"0",
            "values":[
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
               "0",
            ],
            "answer":"0"
         },

         {
            "main":"Left Flexion MCP",
            "subMain":"Normal Endpoint is 90 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].TextField6[158]",
            "defaultVal":"90",
            "values":[
               "90",
               "85",
               "80",
               "75",
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
            ],
            "answer":"90"
         },
         {
            "main":"Left Flexion PIP",
            "subMain":"Normal Endpoint is 100 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].TextField6[175]",
            "defaultVal":"100",
            "values":[
               "100",
               "95",
               "90",
               "85",
               "80",
               "75",
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
            ],
            "answer":"100"
         },
         {
            "main":"Left Flexion DIP",
            "subMain":"Normal Endpoint is 70 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].TextField6[159]",
            "defaultVal":"70",
            "values":[
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
            ],
            "answer":"70"
         },
         {
            "main":"Left Extension MCP",
            "subMain":"Normal Endpoint is 0 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].TextField6[160]",
            "defaultVal":"0",
            "values":[
               "90",
               "85",
               "80",
               "75",
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
               "0",
            ],
            "answer":"0"
         },
         {
            "main":"Left Flexion PIP",
            "subMain":"Normal Endpoint is 0 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].TextField6[161]",
            "defaultVal":"0",
            "values":[
               "100",
               "95",
               "90",
               "85",
               "80",
               "75",
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
               "0",
            ],
            "answer":"0"
         },
         {
            "main":"Left Flexion DIP",
            "subMain":"Normal Endpoint is 0 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].TextField6[162]",
            "defaultVal":"0",
            "values":[
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
               "0",
            ],
            "answer":"0"
         },
      ]
   },
   {
      "question":"Perform active range of motion and provide the ROM values for ##redHeading##",
      "redHeading":"Ring Finger",
      "sub":"",
      "type":"text",
      "show": true,
      "section": {
         page: "4",
         title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION",
         number: "3"
      },
      "questions":[
         {
            "main":"Right Flexion MCP",
            "subMain":"Normal Endpoint is 90 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].TextField6[135]",
            "defaultVal":"90",
            "values":[
               "90",
               "85",
               "80",
               "75",
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
            ],
            "answer":"90"
         },
         {
            "main":"Right Flexion PIP",
            "subMain":"Normal Endpoint is 100 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].TextField6[148]",
            "defaultVal":"100",
            "values":[
               "100",
               "95",
               "90",
               "85",
               "80",
               "75",
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
            ],
            "answer":"100"
         },
         {
            "main":"Right Flexion DIP",
            "subMain":"Normal Endpoint is 70 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].TextField6[136]",
            "defaultVal":"70",
            "values":[
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
            ],
            "answer":"70"
         },
         {
            "main":"Right Extension MCP",
            "subMain":"Normal Endpoint is 0 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].TextField6[137]",
            "defaultVal":"0",
            "values":[
               "90",
               "85",
               "80",
               "75",
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
               "0",
            ],
            "answer":"0"
         },
         {
            "main":"Right Extension PIP",
            "subMain":"Normal Endpoint is 0 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].TextField6[138]",
            "defaultVal":"0",
            "values":[
               "100",
               "95",
               "90",
               "85",
               "80",
               "75",
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
               "0",
            ],
            "answer":"0"
         },
         {
            "main":"Right Extension DIP",
            "subMain":"Normal Endpoint is 0 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].TextField6[139]",
            "defaultVal":"0",
            "values":[
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
               "0",
            ],
            "answer":"0"
         },

         {
            "main":"Left Flexion MCP",
            "subMain":"Normal Endpoint is 90 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].TextField6[163]",
            "defaultVal":"90",
            "values":[
               "90",
               "85",
               "80",
               "75",
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
            ],
            "answer":"90"
         },
         {
            "main":"Left Flexion PIP",
            "subMain":"Normal Endpoint is 100 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].TextField6[176]",
            "defaultVal":"100",
            "values":[
               "100",
               "95",
               "90",
               "85",
               "80",
               "75",
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
            ],
            "answer":"100"
         },
         {
            "main":"Left Flexion DIP",
            "subMain":"Normal Endpoint is 70 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].TextField6[164]",
            "defaultVal":"70",
            "values":[
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
            ],
            "answer":"70"
         },
         {
            "main":"Left Extension MCP",
            "subMain":"Normal Endpoint is 0 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].TextField6[165]",
            "defaultVal":"0",
            "values":[
               "90",
               "85",
               "80",
               "75",
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
               "0",
            ],
            "answer":"0"
         },
         {
            "main":"Left Flexion PIP",
            "subMain":"Normal Endpoint is 0 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].TextField6[166]",
            "defaultVal":"0",
            "values":[
               "100",
               "95",
               "90",
               "85",
               "80",
               "75",
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
               "0",
            ],
            "answer":"0"
         },
         {
            "main":"Left Flexion DIP",
            "subMain":"Normal Endpoint is 0 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].TextField6[167]",
            "defaultVal":"0",
            "values":[
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
               "0",
            ],
            "answer":"0"
         },
      ]
   },
   {
      "question":"Perform active range of motion and provide the ROM values for ##redHeading##",
      "redHeading":"Little Finger",
      "sub":"",
      "type":"text",
      "show": true,
      "section": {
         page: "4",
         title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION",
         number: "3"
      },
      "questions":[
         {
            "main":"Right Flexion MCP",
            "subMain":"Normal Endpoint is 90 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].TextField6[140]",
            "defaultVal":"90",
            "values":[
               "90",
               "85",
               "80",
               "75",
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
            ],
            "answer":"90"
         },
         {
            "main":"Right Flexion PIP",
            "subMain":"Normal Endpoint is 100 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].TextField6[141]",
            "defaultVal":"100",
            "values":[
               "100",
               "95",
               "90",
               "85",
               "80",
               "75",
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
            ],
            "answer":"100"
         },
         {
            "main":"Right Flexion DIP",
            "subMain":"Normal Endpoint is 70 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].TextField6[142]",
            "defaultVal":"70",
            "values":[
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
            ],
            "answer":"70"
         },
         {
            "main":"Right Extension MCP",
            "subMain":"Normal Endpoint is 0 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].TextField6[143]",
            "defaultVal":"0",
            "values":[
               "90",
               "85",
               "80",
               "75",
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
               "0",
            ],
            "answer":"0"
         },
         {
            "main":"Right Extension PIP",
            "subMain":"Normal Endpoint is 0 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].TextField6[144]",
            "defaultVal":"0",
            "values":[
               "100",
               "95",
               "90",
               "85",
               "80",
               "75",
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
               "0",
            ],
            "answer":"0"
         },
         {
            "main":"Right Extension DIP",
            "subMain":"Normal Endpoint is 0 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].TextField6[145]",
            "defaultVal":"0",
            "values":[
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
               "0",
            ],
            "answer":"0"
         },

         {
            "main":"Left Flexion MCP",
            "subMain":"Normal Endpoint is 90 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].TextField6[168]",
            "defaultVal":"90",
            "values":[
               "90",
               "85",
               "80",
               "75",
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
            ],
            "answer":"90"
         },
         {
            "main":"Left Flexion PIP",
            "subMain":"Normal Endpoint is 100 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].TextField6[169]",
            "defaultVal":"100",
            "values":[
               "100",
               "95",
               "90",
               "85",
               "80",
               "75",
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
            ],
            "answer":"100"
         },
         {
            "main":"Left Flexion DIP",
            "subMain":"Normal Endpoint is 70 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].TextField6[170]",
            "defaultVal":"70",
            "values":[
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
            ],
            "answer":"70"
         },
         {
            "main":"Left Extension MCP",
            "subMain":"Normal Endpoint is 0 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].TextField6[171]",
            "defaultVal":"0",
            "values":[
               "90",
               "85",
               "80",
               "75",
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
               "0",
            ],
            "answer":"0"
         },
         {
            "main":"Left Flexion PIP",
            "subMain":"Normal Endpoint is 0 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].TextField6[172]",
            "defaultVal":"0",
            "values":[
               "100",
               "95",
               "90",
               "85",
               "80",
               "75",
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
               "0",
            ],
            "answer":"0"
         },
         {
            "main":"Left Flexion DIP",
            "subMain":"Normal Endpoint is 0 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].TextField6[173]",
            "defaultVal":"0",
            "values":[
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
               "0",
            ],
            "answer":"0"
         },
      ]
   },
   {
      "question":"Perform active range of motion and provide the ROM values for ##redHeading##",
      "redHeading":"Thumb",
      "sub":"",
      "type":"text",
      "show": true,
      "section": {
         page: "4",
         title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION",
         number: "3"
      },
      "questions":[
         {
            "main":"Right Flexion MCP",
            "subMain":"Normal Endpoint is 100 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].TextField6[126]",
            "defaultVal":"100",
            "values":[
               "100",
               "95",
               "90",
               "85",
               "80",
               "75",
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
            ],
            "answer":"100"
         },
         {
            "main":"Right Flexion IP",
            "subMain":"Normal Endpoint is 90 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].TextField6[124]",
            "defaultVal":"90",
            "values":[
               "90",
               "85",
               "80",
               "75",
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
            ],
            "answer":"90"
         },
         {
            "main":"Right Extension MCP",
            "subMain":"Normal Endpoint is 0 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].TextField6[123]",
            "defaultVal":"0",
            "values":[
               "100",
               "95",
               "90",
               "85",
               "80",
               "75",
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
               "0",
            ],
            "answer":"0"
         },
         {
            "main":"Right Extension IP",
            "subMain":"Normal Endpoint is 0 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].TextField6[125]",
            "defaultVal":"0",
            "values":[
               "90",
               "85",
               "80",
               "75",
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
               "0",
            ],
            "answer":"0"
         },

         {
            "main":"Left Flexion MCP",
            "subMain":"Normal Endpoint is 100 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].TextField6[154]",
            "defaultVal":"100",
            "values":[
               "100",
               "95",
               "90",
               "85",
               "80",
               "75",
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
            ],
            "answer":"100"
         },
         {
            "main":"Left Flexion IP",
            "subMain":"Normal Endpoint is 90 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].TextField6[152]",
            "defaultVal":"90",
            "values":[
               "90",
               "85",
               "80",
               "75",
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
            ],
            "answer":"90"
         },
         {
            "main":"Left Extension MCP",
            "subMain":"Normal Endpoint is 0 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].TextField6[151]",
            "defaultVal":"0",
            "values":[
               "100",
               "95",
               "90",
               "85",
               "80",
               "75",
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
               "0",
            ],
            "answer":"0"
         },
         {
            "main":"Left Extension IP",
            "subMain":"Normal Endpoint is 0 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[3].TextField6[153]",
            "defaultVal":"0",
            "values":[
               "90",
               "85",
               "80",
               "75",
               "70",
               "65",
               "60",
               "55",
               "50",
               "45",
               "40",
               "35",
               "30",
               "25",
               "20",
               "15",
               "10",
               "5",
               "0",
            ],
            "answer":"0"
         },
      ]
   },  
   {
      "question":"Is there a gap between the pad of the thumb and fingers for ##redHeading##?",
      "redHeading":"Right Hand",
      "sub":"If yes indicate the gap in centimeters",
      "type":"radioTiles",
      "multi": false,
      "show": true,
      "textarea": false,
      "small": true,
      "cols": 2,
      "section": {
         page: "4",
         title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION",
         number: "3"
      },
      "questions":[
         {
            "main":"Yes",
            "maxLength":5,
            "dbqName":"form1[0].#subform[3].#area[38].CheckBox37[24]",
            "answer":"",
            "textarea": true,
            "textdbqName" : "form1[0].#subform[3].TextField6[177]",
            "placeholder": "Gap in cm",
            "textAnswer": ""
         },
         {
            "main":"No",
            "dbqName":"form1[0].#subform[3].#area[38].CheckBox37[25]",
            "answer":"",
         },
      ],
      "answer":"",
      "textAnswer": ""
   },
   {
      "question":"Is there a gap between the pad of the thumb and fingers for ##redHeading##?",
      "redHeading":"Left Hand",
      "sub":"If yes indicate the gap in centimeters",
      "type":"radioTiles",
      "multi": false,
      "show": true,
      "textarea": false,
      "small": true,
      "cols": 2,
      "section": {
         page: "4",
         title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION",
         number: "3A"
      },
      "questions":[
         {
            "main":"Yes",
            "maxLength":5,
            "dbqName":"form1[0].#subform[3].#area[40].CheckBox37[28]",
            "answer":"",
            "textarea": true,
            "textdbqName" : "form1[0].#subform[3].TextField6[180]",
            "placeholder": "Gap in cm",
            "textAnswer": ""
         },
         {
            "main":"No",
            "dbqName":"form1[0].#subform[3].#area[40].CheckBox37[29]",
            "answer":"",
         },
      ],
      "answer":"",
      "textAnswer": ""
   },
   {
      "question":"Is there a gap between the finger and proximal transverse crease of the hand on maximal finger flexion for ##redHeading##?",
      "redHeading":"Right Hand",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "5",
         title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION",
         number: "3A"
      },
      "presidence":"Yes",
      "ref":1,
      "dbqName_yes":"form1[0].#subform[3].#area[39].CheckBox37[26]",
      "dbqName_no":"form1[0].#subform[3].#area[39].CheckBox37[27]",
      "answer":"",
   },
   {
      "question":"Gap between the finger and proximal transverse crease of the hand on maximal finger flexion for ##redHeading##",
      "redHeading":"Right Hand",
      "sub":"",
      "type":"text",
      "show": false,
      "refId":1,
      "section": {
         page: "4",
         title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION",
         number: "3"
      },
      "questions":[
         {
            "main":"Index Finger",
            "subMain":"Maximal finger flexion in cm",
            "type":"number",
            "dbqName":"form1[0].#subform[3].TextField6[178]",
         },
         {
            "main":"Long Finger",
            "subMain":"Maximal finger flexion in cm",
            "type":"number",
            "dbqName":"form1[0].#subform[3].TextField6[179]",
         },
      ]
   },
   {
      "question":"Is there a gap between the finger and proximal transverse crease of the hand on maximal finger flexion for ##redHeading##?",
      "redHeading":"Left Hand",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "5",
         title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION",
         number: "3A"
      },
      "presidence":"Yes",
      "ref":1,
      "dbqName_yes":"form1[0].#subform[3].#area[41].CheckBox37[30]",
      "dbqName_no":"form1[0].#subform[3].#area[41].CheckBox37[31]",
      "answer":"",
   },
   {
      "question":"Gap between the finger and proximal transverse crease of the hand on maximal finger flexion for ##redHeading##",
      "redHeading":"Left Hand",
      "sub":"",
      "type":"text",
      "show": false,
      "refId":1,
      "section": {
         page: "4",
         title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION",
         number: "3A"
      },
      "questions":[
         {
            "main":"Index Finger",
            "subMain":"Maximal finger flexion in cm",
            "type":"number",
            "dbqName":"form1[0].#subform[3].TextField6[181]",
         },
         {
            "main":"Long Finger",
            "subMain":"Maximal finger flexion in cm",
            "type":"number",
            "dbqName":"form1[0].#subform[3].TextField6[182]",
         },
      ]
   },
   {
      "question":"Is there objective evidence of localized tenderness or pain on palpation of the joint or associated soft tissue for ##redHeading##? ",
      "redHeading": "Right Hand",
      "sub":"",
      "type":"yesno",
      "show": true,
      "multi": true,
      "section": {
         page: "7",
         title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION",
         number: "3E"
      },
      "presidence":"Yes",
      "maxLength":45,
      "ref":0,
      "dbqName_yes":"form1[0].#subform[3].#area[42].CheckBox37[32]",
      "dbqName_no":"form1[0].#subform[3].#area[42].CheckBox37[33]",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please explain. Include location, severity, and relationship to condition(s)",
      "textdbqName":"form1[0].#subform[3].TextField6[184]",
      "textanswer":""
   },
   {
      "question":"Is there objective evidence of localized tenderness or pain on palpation of the joint or associated soft tissue for ##redHeading##? ",
      "redHeading": "Left Hand",
      "sub":"",
      "type":"yesno",
      "show": true,
      "multi": true,
      "section": {
         page: "7",
         title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION",
         number: "3E"
      },
      "presidence":"Yes",
      "maxLength":45,
      "ref":0,
      "dbqName_yes":"form1[0].#subform[3].#area[43].CheckBox37[34]",
      "dbqName_no":"form1[0].#subform[3].#area[43].CheckBox37[35]",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please explain. Include location, severity, and relationship to condition(s)",
      "textdbqName":"form1[0].#subform[3].TextField6[183]",
      "textanswer":""
   }, 
   {
      "question":"If noted on examination, which digit exhibited pain in ##redHeading##? ",
      "redHeading": "Right Hand",
      "sub":"Check all that apply",
      "type":"radioTiles",
      "multi": true,
      "show": true,
      "small": true,
      "partial": true,
      "cols": 2,
      "questions":[
         {
            "main":"Index finger",
            "dbqName":"form1[0].#subform[3].CheckBox37[36]",
            "answer":""
         },
         {
            "main":"Long finger",
            "dbqName":"form1[0].#subform[3].CheckBox37[37]",
            "answer":""
         },
         {
            "main":"Ring finger",
            "dbqName":"form1[0].#subform[3].CheckBox37[38]",
            "answer":""
         },
         {
            "main":"Little finger",
            "dbqName":"form1[0].#subform[3].CheckBox37[39]",
            "answer":""
         },
         {
            "main":"Thumb",
            "dbqName":"form1[0].#subform[3].CheckBox37[40]",
            "answer":""
         },
         {
            "main":"None",
            "dbqName":"pass_this_question",
            "partialField": true,
            "answer":""
         }          
      ],
      "answer":""
   },
   {
      "question":"If noted on examination, which digit exhibited pain in ##redHeading##? ",
      "redHeading": "Left Hand",
      "sub":"Check all that apply",
      "type":"radioTiles",
      "multi": true,
      "show": true,
      "small": true,
      "partial": true,
      "cols": 2,
      "questions":[
         {
            "main":"Index finger",
            "dbqName":"form1[0].#subform[3].CheckBox37[41]",
            "answer":""
         },
         {
            "main":"Long finger",
            "dbqName":"form1[0].#subform[3].CheckBox37[42]",
            "answer":""
         },
         {
            "main":"Ring finger",
            "dbqName":"form1[0].#subform[3].CheckBox37[43]",
            "answer":""
         },
         {
            "main":"Little finger",
            "dbqName":"form1[0].#subform[3].CheckBox37[44]",
            "answer":""
         },
         {
            "main":"Thumb",
            "dbqName":"form1[0].#subform[3].CheckBox37[45]",
            "answer":""
         },
         {
            "main":"None",
            "dbqName":"pass_this_question",
            "partialField": true,
            "answer":""
         }            
      ],
      "answer":""
   },
   {
      "question":"Is there evidence of pain in ##redHeading##?",
      "redHeading": "Right Hand",
      "sub":"",
      "type":"radioTiles",
      "multi": true,
      "partial": true,
      "show": true,
      "small": true,
      "cols": 2,
      "section": {
         page: "6",
         title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION",
         number: "3A"
      },
      "questions":[
               {
                  "main":"Weight-bearing",
                  "dbqName":"form1[0].#subform[5].#area[53].CheckBox37[102],form1[0].#subform[5].CheckBox37[95]",
                  "answer":""
               },
               {
                  "main":"Non-weight bearing",
                  "dbqName":"form1[0].#subform[5].#area[53].CheckBox37[102],form1[0].#subform[5].CheckBox37[96]",
                  "answer":""
               },
               {
                  "main":"Active motion",
                  "dbqName":"form1[0].#subform[5].#area[53].CheckBox37[102],form1[0].#subform[5].CheckBox37[98]",
                  "answer":""
               },
               {
                  "main":"Passive motion",
                  "dbqName":"form1[0].#subform[5].#area[53].CheckBox37[102],form1[0].#subform[5].CheckBox37[97]",
                  "answer":""
               },
               {
                  "main":"On Rest/Non-movement",
                  "dbqName":"form1[0].#subform[5].#area[53].CheckBox37[102],form1[0].#subform[5].CheckBox37[99]",
                  "answer":""
               },
               {
                  "main":"Causes functional loss",
                  "dbqName":"form1[0].#subform[5].#area[53].CheckBox37[102],form1[0].#subform[5].CheckBox37[100]",
                  "answer":"",
                  "textarea": true,
                  "maxLength":90,
                  "textdbqName" : "form1[0].#subform[5].TextField6[253]",
                  "placeholder": "describe in the functional loss",
                  "textAnswer": ""
               },
               {
                  "main":"Does not result in functional loss",
                  "dbqName":"form1[0].#subform[5].#area[53].CheckBox37[102],form1[0].#subform[5].CheckBox37[101]",
                  "answer":""
               },
               {
                  "main":"None",
                  "partialField": true,
                  "dbqName":"form1[0].#subform[5].#area[53].CheckBox37[103]",
                  "answer":""
               }            
            ],
            "answer":""
   },
   {
      "question":"Is there evidence of pain in ##redHeading##?",
      "redHeading": "Left Hand",
      "sub":"",
      "type":"radioTiles",
      "multi": true,
      "partial": true,
      "show": true,
      "small": true,
      "cols": 2,
      "section": {
         page: "6",
         title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION",
         number: "3A"
      },
      "questions":[
               {
                  "main":"Weight-bearing",
                  "dbqName":"form1[0].#subform[5].#area[52].CheckBox37[93],form1[0].#subform[5].CheckBox37[86]",
                  "answer":""
               },
               {
                  "main":"Non-weight bearing",
                  "dbqName":"form1[0].#subform[5].#area[52].CheckBox37[93],form1[0].#subform[5].CheckBox37[87]",
                  "answer":""
               },
               {
                  "main":"Active motion",
                  "dbqName":"form1[0].#subform[5].#area[52].CheckBox37[93],form1[0].#subform[5].CheckBox37[89]",
                  "answer":""
               },
               {
                  "main":"Passive motion",
                  "dbqName":"form1[0].#subform[5].#area[52].CheckBox37[93],form1[0].#subform[5].CheckBox37[88]",
                  "answer":""
               },
               {
                  "main":"On Rest/Non-movement",
                  "dbqName":"form1[0].#subform[5].#area[52].CheckBox37[93],form1[0].#subform[5].CheckBox37[90]",
                  "answer":""
               },
               {
                  "main":"Causes functional loss",
                  "dbqName":"form1[0].#subform[5].#area[52].CheckBox37[93],form1[0].#subform[5].CheckBox37[91]",
                  "answer":"",
                  "textarea": true,
                  "maxLength":90,
                  "textdbqName" : "form1[0].#subform[5].TextField6[254]",
                  "placeholder": "describe in the functional loss",
                  "textAnswer": ""
               },
               {
                  "main":"Does not result in functional loss",
                  "dbqName":"form1[0].#subform[5].#area[52].CheckBox37[93],form1[0].#subform[5].CheckBox37[92]",
                  "answer":""
               },
               {
                  "main":"None",
                  "partialField": true,
                  "dbqName":"form1[0].#subform[5].#area[52].CheckBox37[94]",
                  "answer":""
               }            
            ],
            "answer":""
   },
   {
      "question":"Additional Comments",
      "sub":"",
      "optional": true,
      "type":"textarea",
      "maxLength":375,
      "show": true,
      "section": {
         page: "14",
         title: "REMARKS",
         number: "11A"
      },
      "options":[],
      "dbqName":"form1[0].#subform[13].TextField6[495]",
      "answer":""
   }
]

export default Foot_questions;